/* eslint-disable */
import { gsap } from 'gsap';

export {
    gsap
};
